<template>
  <div class="modal-card" style="600px">
    <div class="modal-card-head">
      <p class="modal-card-title">Confirm Private Mode Action</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </div>
    <div class="modal-card-body">
      <div class="content" v-if="privateModeIsOn">
        <p>You are about to disable Private Mode for terminal {{ terminal.name }}. When Private Mode is disabled, we will begin to collect location data (GPS, Satellite, and Beam data) for this terminal.</p>
        <p>By typing your name below, you are authorizing this terminal have its private mode setting disabled.</p>
      </div>
      <div class="content" v-else>
        <p>You are about to set terminal {{ terminal.name }} into Private Mode. Private Mode prevents the collection of location data (GPS, Satellite, and Beam data) for this terminal.  Note: This feature does not delete data already collected.</p>
        <p>By typing your name below, you are authorizing this terminal to be set to private mode.</p>
      </div>
    </div>
    <footer class="modal-card-foot">
      <b-field grouped>
        <b-input v-model="privateModeSignature" :placeholder="`Type your name (${userName}) here`" class="name-input" spellcheck="false" autocomplete="off" style="width: 300px"></b-input>
        <b-button type="is-primary" :disabled="!canSubmitPrivateMode" @click="executeCommand(privateModeIsOn ? 'privateModeOff' : 'privateModeOn', privateModeIsOn); $emit('close')">
          <span v-if="!privateModeIsOn">Enable Private Mode</span>
          <span v-else>Disable Private Mode</span>
        </b-button>
        <b-button @click="privateModeSignature = null; $emit('close')">Cancel</b-button>  
      </b-field>
    </footer>
  </div>
</template>
<script setup>
import { defineProps, ref, computed } from 'vue';
import { useUserStore } from '../../user/user-store';
import { useTerminalsStore } from '../terminals-store';

const props = defineProps(['privateModeIsOn', 'terminal']);
const store = useTerminalsStore();

const userStore = useUserStore();
const user = computed(() => userStore.getters.user);
const userName = computed(() => `${user.value.firstName} ${user.value.lastName}`);

const privateModeSignature = ref('');
const canSubmitPrivateMode = computed(() => (userName.value == privateModeSignature.value));

const executeCommand = async (cmd) => {
  await store.dispatch('executeTerminalCommand', { id: props.terminal.id, cmd });
}

</script>
